var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0069 0.000106062C40.37 0.000106062 52.0137 11.6438 52.0137 26.0069C52.0137 40.37 40.37 52.0137 26.0069 52.0137C11.6438 52.0137 0.000107873 40.37 0.000107873 26.0069C-0.0407615 11.6845 11.5366 0.0409754 25.8588 0.000106062C25.9082 -3.53541e-05 25.9575 -3.53541e-05 26.0069 0.000106062Z",
    fill: "#16A02C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9863 19.5116L21.7894 36.252L11.0391 26.9443L15.416 23.1945L21.7894 28.6854L36.6095 15.7617L40.9863 19.5116Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveTick);
export default __webpack_public_path__ + "static/media/approveTick.472d79cc9b4ca15e145840bb8e5bdd8d.svg";
export { ForwardRef as ReactComponent };